import { useEffect } from 'react';

export function useConfirmBeforeUnload({
  edited,
  submitting,
  singlePage,
  disableConfirmTabClose,
}: {
  edited: boolean;
  submitting: boolean;
  singlePage?: boolean;
  disableConfirmTabClose: boolean;
}) {
  useEffect(() => {
    if (submitting || singlePage || !edited || disableConfirmTabClose) return;

    const beforeUnload = (e: BeforeUnloadEvent) => {
      e.preventDefault();
    };

    window.addEventListener('beforeunload', beforeUnload);
    return () => window.removeEventListener('beforeunload', beforeUnload);
  }, [disableConfirmTabClose, edited, singlePage, submitting]);
}
